module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploaderBox"
  }, [_c('div', {
    staticClass: "uploaderBox__input"
  }, [_c('input', {
    staticClass: "uploaderBox__file",
    attrs: {
      "type": "file",
      "id": "file_uploader",
      "accept": _vm.accept
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn theme--dark blue",
    attrs: {
      "for": "file_uploader"
    }
  }, [_vm._v("Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "uploaderBox__desc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-icon', {
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        _vm.deleteFile()
      }
    }
  }, [_vm._v("clear")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b61abfc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sell/components/digital_uploader.vue
// module id = 1632
// module chunks = 180